<template>
  <div class="contractManageDet">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="ft12 C787878">
            <span>您现在的位置：</span>
            <span><a href="#" class="text-decoration_none themColor" @click="goHomes">返回上一页</a></span>
            <span class="el-icon-arrow-right"></span>
            <span>订单结算</span>
        </div>
      </div>
      <div class="contractCont padding20" element-loading-spinner="el-icon-loading" v-loading="loading">
         <!-- 基础信息 -->
          <BasicInformation :basicInf="list"></BasicInformation>
          <div v-for="(item,index) in tuples" :key="index">
            <div v-if="dataList[item.jsonName].goods">
              <!-- 可购商品 -->
              <CanshopCar v-if="item.ext2 == 'productArea'" :dataLists="dataList[item.jsonName]" :names="item.name"></CanshopCar>
            </div>
            <div v-if="dataList[item.jsonName]">
               <!-- 销量目标 -->
               <GroupSalesTarget v-if="item.ext2 == 'salesVolume'" :dataLists="dataList[item.jsonName]" :names="item.name"></GroupSalesTarget>
            </div>
            <div v-if="dataList[item.jsonName]">
              <!-- 违约责任 -->
              <BreachContract v-if="item.ext2 == 'contractBreach'" :dataLists="dataList[item.jsonName]" :names="item.name"></BreachContract>
            </div>
            <div v-if="dataList[item.jsonName]">
                <!-- 合同细则 -->
                <ContractDetails v-if="item.ext2 == 'contractDetail'" :dataLists="dataList[item.jsonName]" :names="item.name"></ContractDetails>
            </div>
            <div v-if="dataList[item.jsonName]">
              <!-- 销售范围 -->
              <SalesScope v-if="item.ext2 == 'saleArea'" :dataLists="dataList[item.jsonName]" :names="item.name"></SalesScope>
            </div>
          </div>
          <!-- 附件信息 -->
          <AttachmentInf :filesVo="filesVo"></AttachmentInf>
      </div>
      <div class="textcenter mtb30">
        <el-button v-if="list.signState==1" type="info" plain disabled>已确认</el-button>
        <el-button @click="contractEvent" v-else type="primary">确认签订</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import {FindContractDetailByCode,SaleContractSign} from "@/api/api"; 
import BasicInformation from './Components/BasicInformation' 
import CanshopCar from './Components/CanshopCar' 
import GroupSalesTarget from './Components/GroupSalesTarget' 
import BreachContract from './Components/BreachContract' 
import ContractDetails from './Components/ContractDetails'
import AttachmentInf from './Components/AttachmentInf'
import SalesScope from './Components/SalesScope'
export default {
  data() {
    return {
        code:'', //合同编码
        list:{}, //列表信息
        filesVo:[], //附件信息
        tuples:[], //模块展示信息
        dataList:{}, //模块显示对应内容
        loading:true
    }
  },
  components:{
      BasicInformation,
      CanshopCar,
      GroupSalesTarget,
      BreachContract,
      ContractDetails,
      AttachmentInf,
      SalesScope,
  },
  created(){
      this.code = this.$route.query.code
      this.contractManageList(this.code)
  },
  methods:{
      /**
       * @description: 合同详情
       * @param {*} code  合同编码
       * @return {*}
       * @author: txp
       */
      contractManageList(code){
          FindContractDetailByCode(code).then(res=>{
            this.list = res.result //获取整个list表格
            this.filesVo = res.result.filesVo //获取附件信息模块
            this.tuples = res.result.contractTemplateVo.tuples  //获取除基础信息和附件信息模块外的具体值
            this.dataList = res.result.data //获取除基础信息和附件信息模块外的数据中的type和tasktype,请求获取值
            this.loading = false
          }).catch(error=>{
              this.$message.error(error)
          })
      },
       // 返回上一页
        goHomes(){
           window.history.back();
        },
      // 确认签订合同
      contractEvent(){
        SaleContractSign({
          code:this.code
        }).then(res=>{
          this.$message.success(res.message)
            console.log(res)
        }).catch(error=>{
          this.$message.error(error)
        })
      }
  }
};
</script>
<style lang="scss" scoped>
.contractManageDet {
  max-width: 1000px;
  /deep/ .el-card__header {
    border-bottom: 0;
  }
  /deep/ .el-card__body{
      margin: 0px 10px;
      padding: 0px;
  }
  .clearfix {
    font-size: 16px;
  }
  .contractCont{
      background-color: #fafafa;
  }
}
</style>

